export default __webpack_public_path__ + "static/media/hht2_ep_19.b0003175.png";